module.exports = __webpack_public_path__ + "img/shopping_cart_24px.8b6169a4.svg";